/**
 * @desc 报损结果统计报表-导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.storageReportDamage.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/storageReportDamage/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
